/* eslint-disable import/prefer-default-export */
export const DESKTOP_VERSIONS = ['picoxia_ia', 'picoxia_acq'];
